import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import {
    BaasicTable,
    EmptyState,
    BaasicButton
} from "core/components";
import { ApplicationListLayout, Content, PageNavigation } from "core/layouts";

const ConfirmingReportPumpAndPoleItemListTemplate = function({ confirmingReportPumpAndPoleItemListViewStore }) {
    
    const { tableStore, routes, authorization, rootStore } = confirmingReportPumpAndPoleItemListViewStore;

    return (
        <ApplicationListLayout
            store={confirmingReportPumpAndPoleItemListViewStore}
            authorization={authorization}
        >
            <PageNavigation>
                <BaasicButton 
                    type='button'
                    className="btn btn--base btn--ghost"
                    icon='u-icon u-icon--xsml u-icon--btn-back'
                    onClick={() => rootStore.routerStore.goBack() }
                    label={('LIST_LAYOUT.BACK_BUTTON')}
                />
            </PageNavigation>
            <Content emptyRenderer={renderEmpty(routes)}>
                <div className="card--table">
                    <BaasicTable
                        authorization={authorization}
                        tableStore={tableStore}
                    />
                </div>
            </Content>

        </ApplicationListLayout>
    );
};

function renderEmpty(routes) {
    return (
        <EmptyState
            title="CONFIRMING_REPORT_ITEM.LIST.EMPTY_STATE.TITLE"
            callToAction={routes.create}
        />
    );
}

ConfirmingReportPumpAndPoleItemListTemplate.propTypes = {
    confirmingReportPumpAndPoleItemListViewStore: PropTypes.object.isRequired
};

export default defaultTemplate(ConfirmingReportPumpAndPoleItemListTemplate);